export default __webpack_public_path__ + "static/investing-channel-eb85cc6ed25e0d96a49a02c7b4126348.svg";